import React from "react";
import styled from "styled-components";
import {NavLink} from "react-router-dom";
import Color from "../../../assets/Colors";

export default function ItemMenu({name, path, base, activeClassName}) {
   return (
      <Item base={base}>
         <NavLink to={path || "/"} activeClassName={activeClassName}>
            {name}
         </NavLink>
      </Item>
   );
}

const Item = styled.li`
   padding: 0;
   margin: 0;
   list-style: none;
   font-size: 1em;
   color: ${props => props.base};

   & a {
      color: ${props => props.base};
      text-transform: uppercase;
      font-size: 1em;
      letter-spacing: 1px;
      padding-bottom: 0.5em;
      font-weight: 200;

      & .icon {
         fill: ${props => props.base};
      }
   }
   @media screen and (max-width: 1600px) {
      & a {
         font-size: 0.9em;
         letter-spacing: 0;
      }
   }

   @media screen and (max-width: 1400px) {
      & a {
         font-size: 0.8em;
      }
   }

   @media screen and (max-width: 800px) {
      & a {
         font-size: 0.5em;
      }
   }

   & a.current {
      border-bottom: 1px solid ${props => props.base};
   }
   & a.navCurrent {
      color: ${Color.secondary};
      border-bottom: none;

      & .icon {
         fill: ${Color.secondary};
      }
   }
`;

ItemMenu.defaultProps = {
   activeClassName: "current",
};
